module.exports = __webpack_public_path__ + "static/media/X.b7ac926c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/agent/Tabs/Payments/img/X.svg
// module id = 382
// module chunks = 16